import React from 'react';
import { CheckIcon, KeyRoundIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { exerciseTypes } from '../data/landing';
export function PracticeSection() {
  return <section aria-labelledby="practica" className="bg-cream" data-id="element-169" data-mp="2x9v0a9a3ctrl">
      
    </section>;
}